import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-cle-contractor-details-wrapper',
  templateUrl: './cle-contractor-details-wrapper.component.html',
  styleUrls: ['./cle-contractor-details-wrapper.component.scss'],
})
export class CleContractorDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
